// extracted by mini-css-extract-plugin
export default {"tabPanel":"SettingsSettings_tabPanel__LRPAW","root":"SettingsSettings_root__3Lccj","tabList":"SettingsSettings_tabList__gXITd"};